module.exports = __webpack_public_path__ + "static/media/image-placeholder.e9425c78.webp";